import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ls from "local-storage";
import * as CONFIG from "./_config";

toast.configure();
const axios = require("axios");

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.Departments();
      ls.set("redirectTo", window.location.href);
    }
  }

  componentDidMount() {
    this.Departments();
    this.renderDepartment();
    ls.set("redirectTo", window.location.href);
  }

  Departments() {
    const data = new FormData();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    data.append("method", "POST");
    // set user id
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetCategoriesForCoupons/${UserToken}`;

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        // console.log('GetProductCategories',res.data.GetProductCategories);
        if (res.data.GetProductCategories) {
          let department_list = res.data.GetProductCategories;
          department_list.sort((a, b) =>
            a.ProductCategoryName.localeCompare(b.ProductCategoryName)
          );

          let cnt = department_list.filter(
            (x) =>
              x.ProductCategoryId !== 10001 && x.ProductCategoryId !== 10002
          ).length;

          this.setState({
            departments: res.data.GetProductCategories,
            visible_dept: cnt,
          });
          // console.log('res.data.GetProductCategories', res.data.GetProductCategories);
        } else {
          this.setState({ departments: [] });
        }
      })
      .catch(function (response) {
        //console.log(response);
      });
  }

  renderDepartment() {
    var dept_info = CONFIG.DATA.DEPARTMENTS || [];
    const departments = this.state.departments || [];

    if (departments?.length && CONFIG.DATA.BACKEND_HOST === "eldens") {
      const isFloralAvailable = departments.some(
        d => d.ProductCategoryName?.toLowerCase() === "floral"
      )
      if (!isFloralAvailable) {
        departments.unshift({
          DepartmentImageUrl: "/assets/images/flower.png",
          NoOfCoupons: 0,
          ProductCategoryId: 0,
          ProductCategoryName: "Floral",
        })
      }
    }

    if (
      departments &&
      departments.length > 0 &&
      Object.keys(dept_info.length) == 0 &&
      dept_info.length == 0
    ) {
      return departments.map((value, index) =>
        value.ProductCategoryId !== 10001 &&
        value.ProductCategoryId !== 10002 ? (
          <div
            key={index}
            className="wpb_column vc_column_container vc_col-sm-1/5 mb-5"
          >
            <div className="vc_column-inner">
              <div className="wpb_wrapper">
                <div className="vc-hoverbox-wrapper  vc-hoverbox-shape--rounded vc-hoverbox-align--center vc-hoverbox-direction--default vc-hoverbox-width--100">
                  <div className="vc-hoverbox" style={{ perspective: 864 }}>
                    <div
                      className="vc-hoverbox-inner"
                      style={{ minHeight: 250 }}
                    >
                      <div
                        className="vc-hoverbox-block vc-hoverbox-front"
                        style={{
                          background: "url(" + value.DepartmentImageUrl + ")",
                          backgroundSize: "cover",
                        }}
                      >
                        {CONFIG.DATA.THEME && CONFIG.DATA.THEME === 2 ? (
                          <div className="">
                            <span className="dpt_title dpt_title2">
                              {" "}
                              {value.ProductCategoryName}
                            </span>
                          </div>
                        ) : (
                          <div className="vc-hoverbox-block-inner vc-hoverbox-front-inner">
                            <h2
                              style={{
                                fontSize: 37,
                                color: "#ffffff",
                                textAlign: "center",
                                fontFamily: "Lobster",
                                fontWeight: 400,
                                fontStyle: "normal",
                              }}
                              className="vc_custom_heading text-shadow"
                            >
                              {value.ProductCategoryName}
                            </h2>
                          </div>
                        )}
                      </div>

                      <div
                        className="vc-hoverbox-block vc-hoverbox-back"
                        style={{
                          backgroundColor: "#ebebeb",
                        }}
                      >
                        <div className="vc-hoverbox-block-inner vc-hoverbox-back-inner">
                          <h2 style={{ textAlign: "center" }}>
                            {value.ProductCategoryName}
                          </h2>
                          <p
                            style={{
                              color: "#848484",
                            }}
                          ></p>
                          <div className="vc_btn3-container vc_btn3-inline">
                            <Link
                              to={
                                "/department/" +
                                value.ProductCategoryName.replace(/\s/g, "-")
                                  .replace(/\//g, "_")
                                  .toLowerCase()
                              }
                              className="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-modern vc_btn3-color-danger"
                            >
                              Know More...
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )
      );
    } else if (typeof dept_info !== "undefined" && dept_info.length > 0) {
      return dept_info.map((value, index) => (
        <div
          key={index}
          className="wpb_column vc_column_container vc_col-sm-1/5 mb-5"
        >
          <div className="vc_column-inner">
            <div className="wpb_wrapper">
              <div className="vc-hoverbox-wrapper  vc-hoverbox-shape--rounded vc-hoverbox-align--center vc-hoverbox-direction--default vc-hoverbox-width--100">
                <div className="vc-hoverbox" style={{ perspective: 864 }}>
                  <div className="vc-hoverbox-inner" style={{ minHeight: 250 }}>
                    <div
                      className="vc-hoverbox-block vc-hoverbox-front"
                      style={{
                        background: "url(" + value.dept_image + ")",
                        backgroundSize: "cover",
                      }}
                    >
                      {CONFIG.DATA.THEME && CONFIG.DATA.THEME === 2 ? (
                        <div className="">
                          <span className="dpt_title dpt_title2">
                            {" "}
                            {value.departmentname}
                          </span>
                        </div>
                      ) : (
                        <div className="vc-hoverbox-block-inner vc-hoverbox-front-inner">
                          <h2
                            style={{
                              fontSize: 37,
                              color: "#ffffff",
                              textAlign: "center",
                              fontFamily: "Lobster",
                              fontWeight: 400,
                              fontStyle: "normal",
                            }}
                            className="vc_custom_heading text-shadow"
                          >
                            {value.departmentname}
                          </h2>
                        </div>
                      )}
                    </div>

                    <div
                      className="vc-hoverbox-block vc-hoverbox-back"
                      style={{ backgroundColor: "#ebebeb" }}
                    >
                      <div className="vc-hoverbox-block-inner vc-hoverbox-back-inner">
                        <h2 style={{ textAlign: "center" }}>
                          {value.departmentname}
                        </h2>
                        <p style={{ color: "#848484" }}></p>
                        <div className="vc_btn3-container vc_btn3-inline">
                          <Link
                            to={
                              "/department/" +
                              value.slug
                                .replace(/\s/g, "-")
                                .replace(/\//g, "_")
                                .toLowerCase()
                            }
                            className="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-modern vc_btn3-color-danger"
                          >
                            Know More...
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ));
    } else {
      return <div className="content"></div>;
    }
  }

  render() {
    return (
      <div>
        <div className="main-container default-page mt-2 pt-2">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">Departments</h2>
                      <ol className="breadcrumb">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href="/department">Departments</a>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <header className="entry-header">
                  <h1 className="entry-title">Departments</h1>
                </header>
                <div className="breadcrumbs">
                  <Link to="/">Home</Link>
                  <span className="separator">/</span>
                  <span>Departments</span>
                </div>
              </div>
            </div>
          )}
          <div className="clearfix" />
          <div className="container">
            <div className="row1">
              <div className="col-xs-12 ">
                <div className="page-content default-page">
                  <article className="post-8107 page type-page status-publish hentry">
                    <div className="entry-content">
                      <div style={{ height: "40px" }}></div>
                      <div className="vc_row wpb_row vc_row-fluid">
                        <div className="row-container">
                          <div className="wpb_column vc_column_container vc_col-sm-12">
                            <div className="vc_column-inner">
                              <div className="wpb_wrapper">
                                <div className="vc_wp_text wpb_content_element">
                                  <div className="widget widget_text">
                                    {" "}
                                    <div className="textwidget">
                                      <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                        <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                          {this.renderDepartment()}

                                          {this.state.visible_dept === 0 ? (
                                            <div className="content">
                                              <div className="overlay">
                                                <div className="overlay-content">
                                                  <h3>No Departments found</h3>
                                                  <div
                                                    style={{ height: "100px" }}
                                                  ></div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
                <div id="comments" className="comments-area"></div>
                {/* #comments .comments-area */}{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Contact;
